/**
 * Phone number utility functions
 */

export const censorPhoneNumber = (phoneNumber: string): string => {
    // แปลง 0812345678 เป็น 081***5678
    if (phoneNumber.length >= 10) {
        const first3 = phoneNumber.slice(0, 3);
        const last4 = phoneNumber.slice(-4);
        return `${first3}***${last4}`;
    }

    // หากเบอร์โทรสั้นกว่า 10 หลัก ให้แสดงแบบบางส่วน
    if (phoneNumber.length >= 7) {
        const first2 = phoneNumber.slice(0, 2);
        const last2 = phoneNumber.slice(-2);
        return `${first2}***${last2}`;
    }

    return phoneNumber;
};

export const validatePhoneNumber = (phoneNumber: string): boolean => {
    // ตรวจสอบว่าเป็นเบอร์โทรไทยหรือไม่
    const thaiPhoneRegex = /^[0][6-9]\d{8}$/;
    return thaiPhoneRegex.test(phoneNumber);
};

export const formatPhoneNumber = (phoneNumber: string): string => {
    // แปลงเป็นรูปแบบ 0XX-XXX-XXXX
    if (phoneNumber.length === 10) {
        return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
    }
    return phoneNumber;
}; 